<template>
  <div>
    <h2>
      {{ product.payload.product }}
      <font-awesome-icon class="text-primary" :icon="['far', 'badge-dollar']" :style="iconStyle"></font-awesome-icon>
    </h2>
    <p class="subheading">{{ product.payload.message[0] }}</p>
    <div class="row wrapper">
      <div class="col-1 low">
        <p>{{ $t(`message.spotlightV2.categories.highlights.autoverify_great-deal.low`) }}</p>
      </div>
      <div class="col-10 slider-container">
        <div class="slider">
          <div class="this-vehicle">
            <p>
              {{ $t(`message.spotlightV2.categories.highlights.autoverify_great-deal.thisVehicle`) }}:
              {{
                $n(product.payload.data.thisVehicle, 'currencyDollars', getLanguageCodeForNumericalInternationalization)
              }}
            </p>
            <div class="row">
              <div class="col-6 line-left"></div>
              <div class="col-6 line-right"></div>
            </div>
            <div class="dot mx-auto"></div>
          </div>
          <div class="similar-vehicles">
            <div class="dot mx-auto"></div>
            <div class="row">
              <div class="col-6 line-left"></div>
              <div class="col-6 line-right"></div>
            </div>
            <p>
              {{ $t(`message.spotlightV2.categories.highlights.autoverify_great-deal.similarVehicles`) }}:
              {{
                $n(
                  product.payload.data.similarVehicles,
                  'currencyDollars',
                  getLanguageCodeForNumericalInternationalization
                )
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-1 high">
        <p>{{ $t(`message.spotlightV2.categories.highlights.autoverify_great-deal.high`) }}</p>
      </div>
    </div>
    <div class="info-pill text-center mt-5">
      <p>
        {{
          $t(`message.spotlightV2.categories.highlights.autoverify_great-deal.infoPill`, {
            betterThan: product.payload.data.betterThan,
          })
        }}
      </p>
    </div>
    <hr />
    <p class="footnote">{{ product.payload.message[1] }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GreatDeal',
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['getLanguageCodeForNumericalInternationalization']),
  },
  data() {
    return {
      highlightsProductDataMap: {
        greatDeal: {
          icon: 'info-circle',
        },
      },
      iconStyle: {
        marginLeft: '8px',
        fontSize: '18px',
      },
    };
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.wrapper {
  padding: 15px;
  margin-top: 30px;
}
.low {
  padding-left: 0;
}
.low p,
.high p {
  font-size: 14px;
}
.slider-container {
  padding: 0;
}
.slider {
  background-image: linear-gradient(to right, #a8cfe9, $primary-light);
  height: 4px;
  margin-top: 22px;
  border-radius: 15px;
  display: flex;
}
.this-vehicle {
  margin-left: 14%;
  margin-top: -54px;
  p {
    margin-bottom: 0;
  }
  .line-left {
    border-right: 1px solid #19222b;
  }
}
.similar-vehicles {
  margin-left: 5%;
  margin-top: -3px;
  p {
    margin-top: 0;
  }
  .line-right {
    border-left: 1px solid #19222b;
  }
}
.this-vehicle p,
.similar-vehicles p {
  font-size: 14px;
  font-weight: 500;
  color: rgb(25, 34, 43);
}
.dot {
  height: 11px;
  width: 11px;
  background-color: black;
  border-radius: 50%;
  border: 2px solid white;
}
.line-left,
.line-right {
  height: 14px;
}
.info-pill {
  background: #f0f4f7;
  border-radius: 25px;
  p {
    padding: 8px;
    font-size: 14px;
  }
}
hr {
  color: #dae2ea;
  margin-top: 40px;
}
.footnote {
  font-size: 14px;
}

@media only screen and (max-width: 576px) {
  .slider-container {
    padding-right: 15px;
    padding-left: 15px;
  }
  .this-vehicle,
  .similar-vehicles {
    white-space: nowrap;
  }
  .this-vehicle {
    margin-left: -20px;
  }
  .similar-vehicles {
    margin-left: -46px;
  }
  .high {
    padding-left: 0;
  }
}
</style>
